import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  CREATE_MRN_CATEGORY: `${SLICE_NAME}/create_mrn_category`,
  UPDATE_MRN_CATEGORY: `${SLICE_NAME}/update_mrn_category`,
  DELETE_MRN_CATEGORY: `${SLICE_NAME}/delete_mrn_category`,
  RETRIEVE_MRN_CATEGORY: `${SLICE_NAME}/get_mrn_category`,
  RETRIEVE_MANY_MRN_CATEGORIES: `${SLICE_NAME}/get_many_mrn_categories`,
} as const;
